import InstantMessagePayload from 'owa-service/lib/contract/InstantMessagePayload';
import onPresenceChanged from '../presenceManager/onPresenceChanged';
import onSignOn from '../presenceManager/onSignOn';
import { addOthersChatMessage } from '../actions/ucmaActions';
import { addChatNotification } from './startChat';

export default function onUcmaNotification(notification: InstantMessagePayload) {
    switch (notification.PayloadType) {
        case 'NewChatMessageToast':
            addChatNotification(notification);
            break;

        case 'NewChatMessage':
            addOthersChatMessage(notification);
            break;

        case 'QueryUserPresenceChange':
        case 'UpdateUserPresence':
        case 'UserPresenceChange':
            onPresenceChanged(notification);
            break;

        case 'SignOn':
            onSignOn(notification);
            break;

        default:
            break;
    }
}
